import { apiSlice } from './apiSlice';

export interface SearchUsersParams {
  search?: string;
  userLoginType?: string;
  userType?: string;
  fromDate?: string;
  toDate?: string;
  take?: number;
  skip?: number;
}

export interface SearchUsersResponse {
  count: number;
  data: any[];
}

export const searchUsersApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    searchUsers: builder.query<SearchUsersResponse, SearchUsersParams>({
      query: (params) => ({
        url: '/users',
        method: 'GET',
        params,
      }),
      providesTags: ['User'],
    }),
  }),
});

export const { useSearchUsersQuery } = searchUsersApi;
